// src/hooks/useMap.ts
import { useState } from 'react';

interface MapSettings {
  baseMap: 'osm' | 'satellite' | 'terrain';
  contourOpacity: number;
  showPoints: boolean;
}

export const useMap = () => {
  const [settings, setSettings] = useState<MapSettings>({
    baseMap: 'osm',
    contourOpacity: 0.7,
    showPoints: false
  });

  const updateSettings = (newSettings: Partial<MapSettings>) => {
    setSettings(prev => ({
      ...prev,
      ...newSettings
    }));
  };

  return {
    settings,
    updateSettings
  };
};

export default useMap;